import React, { useState, useEffect, useContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../stylesheets/style.scss";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { Col, Button, FormGroup, Label, Input } from "reactstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { UserConsumer } from "../../../../UserContext";
import { Designation_API } from "../designationAPIs";
import { AlertPopups } from "../../../../components/AlertPopups";

const validation = Yup.object().shape({
	selectDepartment: Yup.string()
		.required("Select Department")
		.typeError("Invalid input")
		.nullable(),
	title: Yup.string()
		.required("Title is required")
		.typeError("Invalid input"),
});

const CreateDesignation = () => {
	const userDetails = useContext(UserConsumer);
	const headers = {
		Authorization: `Bearer ${userDetails.token}`,
	};
	const intialState = {
		title: "",
		selectDepartment: { value: null, label: null },
	};
	const [formState, setFormState] = useState(intialState);
	useEffect(() => {
		axios.get(Designation_API.GetDepartment, headers).then((res) => {
			//will be used later
			// setDepartments(
			// 	res.data.map((item) => ({ value: item.id, label: item.name }))
			// );
		});
	}, []);
	console.log(formState.title);
	return (
		<>
			<Formik
				initialValues={formState}
				enableReinitialize={true}
				validationSchema={validation}
				validateOnChange={true}
				onSubmit={() => {
					axios
						.post(
							Designation_API.CreateDesignation,
							{ designationName: formState.title },
							{
								headers: headers,
							}
						)
						.then((res) => {
							if (res.status === 200) {
								setFormState(intialState);
								AlertPopups.successAlert.fire({
									text: "Designation Created Successfully",
								});
							}
						})
						.catch((e) => {
							AlertPopups.ErrorAlert(e.message);
						});
				}}
			>
				{({ errors, handleSubmit }) => (
					<form onSubmit={handleSubmit} className="itemReqForm">
						<FormGroup
							row
							id="row0"
							className="bottom-spacing topBorders "
						>
							<Label sm={12}>Add Designation</Label>
						</FormGroup>
						<FormGroup row className="bottom-spacing rowStyle1">
							<Label for="title" sm={2}>
								Designation Title
								<span className="required">*</span>
							</Label>
							<Col sm={10}>
								<Input
									type="text"
									name="title"
									id="title"
									className={`formValueInput ${
										errors.title
											? "h-auto invalid"
											: "h-auto"
									}`}
									onChange={(value, event) => {
										console.log();
										setFormState({
											...formState,
											[value.target.name]:
												value.target.value,
										});
									}}
									value={formState.title}
									maxLength="500"
								/>
							</Col>
						</FormGroup>
						<FormGroup row className="btns mt-3">
							<Button
								className="submit-btn leftBtn"
								type="submit"
							>
								Create
							</Button>
						</FormGroup>
					</form>
				)}
			</Formik>
		</>
	);
};

export default CreateDesignation;
